// extracted by mini-css-extract-plugin
export default {"overlay":"styles-module--overlay--09bfe","inner":"styles-module--inner--e0359","close":"styles-module--close--04152"};